import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { assertPermissionsWithoutRpc } from '@/api/permissions';
import { getSpaceEndpointUrl } from '@/api/services/serverless/space';
import { DISTANCES } from '@/api/services/serverless/space-collections';
import { SEARCH_TEMPLATES } from '@/components/Serverless/SpaceCollections/create-collection-form';
import { head } from '@/router/Head';

// What a link can preset. A value that does not parse is dropped, so the form falls back to its default.
const createCollectionSearchSchema = z.object({
  name: z.coerce.string().optional().catch(undefined),
  template: z.enum(SEARCH_TEMPLATES).optional().catch(undefined),
  size: z.coerce.number().int().positive().optional().catch(undefined),
  distance: z.enum(DISTANCES).optional().catch(undefined),
});

export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/create-collection',
)({
  validateSearch: createCollectionSearchSchema,
  staticData: {
    title: 'Create Collection',
  },
  beforeLoad: async ({ context: { queryClient, spaceQuery }, params }) => {
    // The space data plane enforces it, so no RPC refuses in its place: check it up front.
    assertPermissionsWithoutRpc(['write:serverless_data'], { queryClient, accountId: params.accountId });

    // No endpoint, nowhere to create it: the Collections tab says the space is not ready yet.
    const { space } = await queryClient.ensureQueryData(spaceQuery);
    if (!getSpaceEndpointUrl(space)) {
      throw redirect({ to: '/accounts/$accountId/serverless-spaces/$spaceId/collections', params, replace: true });
    }
  },
  head,
  component: lazyRouteComponent(
    () => import('@/components/Serverless/SpaceCollections/SpaceCollectionCreate'),
    'SpaceCollectionCreate',
  ),
});
